export default __webpack_public_path__ + "static/media/media-placeholder.49c89fca.svg";